import { frontendURL } from 'dashboard/helper/URLHelper.js';
import SettingsWrapper from '../SettingsWrapper.vue';

import CampaignTemplatesPage from './CampaignTemplatesPage.vue';

const meta = {
  permissions: ['administrator'],
};

const marketingAutomationRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/campaign-templates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'campaign_templates_index',
          meta,
          component: CampaignTemplatesPage,
        },
      ],
    },
  ],
};

export default marketingAutomationRoutes;
